import React, { type Dispatch } from 'react';
import { styled } from 'baseui';
import BlockFormatDropDown from './toolbar-components/BlockFormatDropDown';
import ListFormatDropDown from './toolbar-components/ListFormatDropDown';
import TextStyleOptions from './toolbar-components/TextStyleOptions';
import ElementFormatDropDown from './toolbar-components/ElementFormatDropDown';
const ToolbarContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  marginBottom: $theme.sizing.scale0,
  background: $theme.colors.primaryB,
  padding: $theme.sizing.scale100,
  borderTopLeftRadius: $theme.sizing.scale400,
  borderTopRightRadius: $theme.sizing.scale400,
  verticalAlign: 'middle',
  flexWrap: 'wrap',
  gap: $theme.sizing.scale200
}));
const ToolbarPlugin = ({
  setIsLinkEditMode
}: {
  setIsLinkEditMode: Dispatch<boolean>;
}) => {
  return <ToolbarContainer>
      <TextStyleOptions setIsLinkEditMode={setIsLinkEditMode} />
      <BlockFormatDropDown />
      <ListFormatDropDown />
      <ElementFormatDropDown />
    </ToolbarContainer>;
};
export default ToolbarPlugin;